import { Button, Card, Col, Row, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EducationPageChrome from '@/pages/education/components/EducationPageChrome';

const { Paragraph } = Typography;

export default function TransportHubPage() {
  const { t } = useTranslation('education');
  const navigate = useNavigate();

  const cards = [
    { path: '/education/transport/routes', title: t('transportRoutes'), desc: t('transportRoutesIntro') },
    {
      path: '/education/transport/boarding',
      title: t('transportBoarding'),
      desc: t('transportBoardingIntro'),
    },
    {
      path: '/education/transport/enrollments',
      title: t('transportEnrollments'),
      desc: t('transportEnrollmentsIntro'),
    },
    {
      path: '/education/transport/enrollments/bulk',
      title: t('bulkTransportEnrollment'),
      desc: t('bulkTransportEnrollmentIntro'),
    },
  ];

  return (
    <EducationPageChrome title={t('transport')} description={t('transportIntro')}>
      <Row gutter={[16, 16]}>
        {cards.map((card) => (
          <Col xs={24} md={12} key={card.path}>
            <Card size="small" title={card.title}>
              <Paragraph type="secondary">{card.desc}</Paragraph>
              <Button type="primary" onClick={() => navigate(card.path)}>
                {t('open')}
              </Button>
            </Card>
          </Col>
        ))}
      </Row>
    </EducationPageChrome>
  );
}
